import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import Co2QuizMenu from '@/components/co2quiz/Co2QuizMenu.vue';
import Co2QuizQuestionList from '@/components/co2quiz/Co2QuizQuestionList.vue';
import Co2Values from '@/components/co2quiz/Co2Values.vue';
import Co2Averages from '@/components/co2quiz/Co2Averages.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Co2QuizMenu),
    (_unref(route).path === '/co2quiz')
      ? (_openBlock(), _createBlock(Co2QuizQuestionList, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/co2quiz/values')
      ? (_openBlock(), _createBlock(Co2Values, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/co2quiz/averages')
      ? (_openBlock(), _createBlock(Co2Averages, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})